import script from "./RcSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./RcSection.vue?vue&type=script&setup=true&lang=ts"

import "./RcSection.vue?vue&type=style&index=0&id=4882e86c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4882e86c"]])

export default __exports__